import React from 'react';
import ContainerOng from '../components/container/ContainerOng';
import FooterComponent from '../components/container/FooterComponent';

const NeedHelp = () => {
  return (
    <div>
      <ContainerOng />
      <div className="footer-help">
        <FooterComponent />
      </div>
    </div>
  );
};

export default NeedHelp;
